// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackPage_backButton__21af9","btnBack":"BackPage_btnBack__1lMXX","angle":"BackPage_angle__22DR8","left":"BackPage_left__22_uX","backTitle":"BackPage_backTitle__3rrS2"};